function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 256h512v85.337H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 341.337h512v85.326H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 59.359,
  fill: "#ffda44"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M256 295.304c-21.098 0-38.261-17.163-38.261-38.261v-22.957c0-21.098 17.163-38.261 38.261-38.261s38.261 17.163 38.261 38.261v22.957c0 21.098-17.163 38.261-38.261 38.261z",
  fill: "#338af3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M317.217 165.217h-45.913c0-8.451-6.853-15.304-15.304-15.304s-15.304 6.853-15.304 15.304h-45.913c0 8.452 7.363 15.304 15.814 15.304h-.51c0 8.452 6.852 15.304 15.304 15.304 0 8.452 6.852 15.304 15.304 15.304h30.609c8.452 0 15.304-6.852 15.304-15.304 8.452 0 15.304-6.852 15.304-15.304h-.51c8.453 0 15.815-6.852 15.815-15.304z"
});

const SvgEcuador = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEcuador, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ecuador.982a3429.svg";
export { ForwardRef as ReactComponent };